export const PRODUCTS = {
  CAR_INSURANCE: 'new',
  RENEWAL: 'renewal',
  INSTALLMENT: 'installments',
};

export const FLOW_ROOT = 'FlowRoot';
export const MAIN_PRODUCT = 'car-insurance';
export const RENEW_PRODUCT = 'insurance-renewal';
export const NOT_FOUND = 'NotFound';
export const ERROR = 'error';

export const contactPhone = 'tel:8000742';
